import browse from './browse.vue';
import create from './create.vue';
import read from './read.vue';

export default { browse, create, read };
